export const bookingInfoConstants = {
  BOOKING_INFO_REQUEST: 'BOOKING_INFO_REQUEST',
  BOOKING_INFO_SUCCESS: 'BOOKING_INFO_SUCCESS',
  BOOKING_INFO_ERROR: 'BOOKING_INFO_ERROR',
  SHOW_BOOKING_INFO_AT_INDEX: 'SHOW_BOOKING_INFO_AT_INDEX',
  CLOSE_BOOKING_INFO: 'CLOSE_BOOKING_INFO',

  MANY_BOOKING_INFO_REQUEST: 'MANY_BOOKING_INFO_REQUEST',
  MANY_BOOKING_INFO_SUCCESS: 'MANY_BOOKING_INFO_SUCCESS',
  MANY_BOOKING_INFO_ERROR: 'MANY_BOOKING_INFO_ERROR',

  RESET: 'BOOKING_INFO_RESET',
};
